$(document).ready(function () {
  'use strict';

  var shuffleOptions = {
    group: 'all',
    speed: 250,
    easing: 'ease-out',
    itemSelector: '.your-photos-item',
    sizer: null,
    gutterWidth: 0,
    columnWidth: 0,
    delimeter: null,
    buffer: 0,
    initialSort: null,
    throttle: $.throttle || null,
    throttleTime: 300,
    sequentialFadeDelay: 150
  };
  var container = $('.your-photos-wrapper >div:last-of-type').get(0);

  if (container) {
    var yourPhotosShuffle = new window.Shuffle(container, shuffleOptions);

    $('.portfolio-filter a').click(function (event) {
      event.preventDefault();
      var filter = $(this).data('filter');

      yourPhotosShuffle.filter(filter || '');
      $('.portfolio-filter .active').removeClass('active');
      $(this).addClass('active');
    });
  }

});